import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import GitExpertApp from './GitExpertApp';

ReactDOM.render(
    <GitExpertApp />,
  document.getElementById('root')
);
